import React from "react";
import { Checkbox } from "../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../constants";
import "./index.scss";

/**
 * @desc Checkbox sold out for product details form.
 */
export const CheckboxProductSoldOut = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-sold-out-error`,
  };

  const inputProps = {
    id: `${product.sku}-checkbox-product-sold-out`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
  };

  const labelProps = {
    className: "custom-control-label",
    htmlFor: inputProps.id,
    children: "SOLD OUT",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_IS_SOLD_OUT,
  };

  return (
    <div className="checkbox-product-sold-out">
      <Checkbox {...parentProps} />
    </div>
  );
};
